module.exports = __webpack_public_path__ + "img/Postmodernisme_Fane-til-kvinnedagen.20113afd.jpg";